import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import { baseURL, headers } from "../../../../../global/api";
import { setHeading } from "../../../accounts/account.actions";
import { PDFHeader } from "../../../../../global/globalFunctions";
import { DeleteConstructionOrderPaymentApi, GeneratePaymentReceiptPDF } from "./ConstructionOrderPaymentAction";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import MaterialSize from "material-table";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from "moment";


const ConstructionOrderPaymentList = (props) => {
    const role = localStorage.getItem("role");
    const tableRef = React.useRef();

    useEffect(() => {
        props.setHeading("View Order Payments");
    }, []);

    return (
        <>
            <Container fluid>
                <MaterialSize
                    tableRef={tableRef}
                    title="View Order Payments"
                    columns={[
                        { title: 'S.No', field: 'sequenceNumber', editable: 'never' },
                        { title: 'Order #', field: 'orderDetails.sequenceNumber' },
                        { title: 'Customer Name', field: 'orderDetails.customerName' },
                        { title: 'Payment Date', field: 'date', render: (rowData) => moment(rowData.date).format("DD-MM-YYYY"), },
                        { title: 'Payment', field: 'payment' },
                        { title: 'Payment Mode', field: 'paymentMode' },
                        // { title: 'Remaining Balance', field: 'remainingBalance', render: (rowData) => (role === "admin" ? rowData.remainingBalance : "*****") },
                        { title: 'Description', field: 'description' },
                        { title: 'CreatedBy', field: 'userDetails.userName' },
                    ]}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            let url = `${baseURL}/construction/get-order-payments?`;
                            url += "limit=" + query.pageSize;
                            url += "&page=" + (query.page);
                            url += "&search=" + query.search;
                            fetch(url, {
                                method: "GET",
                                headers: headers,
                            }).then((response) => response.json()).then((result) => {
                                resolve({
                                    data: result.data,
                                    page: result.page,
                                    totalCount: result.total_results,
                                });
                            });
                        })
                    }
                    options={{
                        actionsColumnIndex: -1,
                        exportButton: true,
                        exportAllData: true,
                        paging: true,
                        pageSize: 50,
                        emptyRowsWhenPaging: false,
                        pageSizeOptions: [50, 100, 150, 200],
                        headerStyle: {
                            position: "sticky",
                            top: 0,
                            color: "#00BBBB",
                            fontWeight: "550",
                            onRowAdd: "none",
                            whiteSpace: 'nowrap',
                        },
                        rowStyle: {
                            whiteSpace: 'nowrap',
                        },
                        cellStyle: {
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        },
                        exportPdf: (columns, data) => {
                            const unit = "pt";
                            const size = "A4";
                            const orientation = "l";
                            const doc = new jsPDF(orientation, unit, size);
                            PDFHeader(doc, "Order Payment Details");

                            const columnTitles = columns.map(columnDef => columnDef.title);
                            const pdfData = data.map((elt) => [
                                elt.sequenceNumber,
                                elt.orderDetails?.sequenceNumber,
                                elt.orderDetails?.customerName,
                                moment(elt.date).format("DD-MM-YYYY"),
                                elt.payment,
                                elt.paymentMode,
                                elt.remainingBalance,
                                elt.description,
                                elt.userDetails?.userName,
                            ]);
                            let content = {
                                startY: 120,
                                startX: 5,
                                head: [columnTitles],
                                body: pdfData,
                                headStyles: { fillColor: "#2980ba", font: 'Amiri', fontSize: 10 },
                                styles: { fontSize: 9 },
                                theme: "grid",
                            };

                            doc.setFontSize(11)
                            doc.setFont("Times New Roman", "Normal")
                            doc.autoTable(content);

                            doc.setProperties({ title: 'Order Payment Details' })
                            doc.output('dataurlnewwindow')
                        },
                    }}
                    editable={{
                        onRowDelete: (oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    props.DeleteConstructionOrderPaymentApi(oldData._id);

                                    if (tableRef.current) {
                                        tableRef.current.onQueryChange();
                                    }
                                }, 600);
                            }),
                    }}
                    actions={[
                        {
                            icon: () => <PictureAsPdfIcon />,
                            tooltip: "Print Payment Receipt",
                            onClick: (event, rowData) => {
                                props.GeneratePaymentReceiptPDF(rowData);
                            },
                        },
                    ]}
                />
            </Container>
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        DeleteConstructionOrderPaymentApi: (paymentId) => dispatch(DeleteConstructionOrderPaymentApi(paymentId)),
        GeneratePaymentReceiptPDF: (data) => dispatch(GeneratePaymentReceiptPDF(data)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isFetchingConstructionOrderPayment: state.ConstructionOrderPaymentReducer.isFetchingConstructionOrderPayment,
});

export default connect(mapStateToProps, mapDispatchToProps)(ConstructionOrderPaymentList);
